import * as tailwind from '../../assets/styles/designtokens/css/tailwind.css';

const dt = (inputClassNames) => {
    undefined;
    let twClassSrt = '';

    inputClassNames?.map((currentClassName) => {
        twClassSrt +=
            tailwind[currentClassName] === undefined
                ? ` ${currentClassName}`
                : ` ${tailwind[currentClassName]}`;
    });

    return twClassSrt?.replace(' ', '');
};

export { dt };
